import Skeleton from "@mui/material/Skeleton";

const RenderLoading = () => {
  return (
    <div className="flex flex-col h-full">
      <div className="flex flex-col h-full">
        <div className="w-full flex justify-between items-center py-3 h-20">
          <Skeleton width="15%" height="100%" variant="rectangular" />
          <Skeleton width="25%" height="100%" variant="rectangular" />
          <Skeleton width="15%" height="100%" variant="rectangular" />
        </div>
        <div className="w-full flex justify-start items-center h-16">
          <Skeleton
            width="10%"
            className="mr-2"
            height="100%"
            variant="rectangular"
          />
          <Skeleton
            width="10%"
            className="mr-2"
            height="100%"
            variant="rectangular"
          />
          <Skeleton
            width="15%"
            className="mr-2"
            height="100%"
            variant="rectangular"
          />
          <Skeleton
            width="10%"
            className="mr-2"
            height="100%"
            variant="rectangular"
          />
          <Skeleton
            width="15%"
            className="mr-2"
            height="100%"
            variant="rectangular"
          />
        </div>
        <div className="h-full w-full my-2">
          <Skeleton width="100%" height="100%" variant="rectangular" />
        </div>
        <div className="flex justify-between w-full h-16">
          <Skeleton width="20%" height="100%" variant="rectangular" />
          <Skeleton width="15%" height="100%" variant="rectangular" />
        </div>
      </div>
    </div>
  );
};

export default RenderLoading;
